module.exports = new __parcel__URL__("sw_genesis_empty.4a95e218.png").toString();